import { FC, useState, useEffect } from 'react';
import { AllieInput } from '../../../../../components';
import { ContainerEditableProducedRate } from './EditableProducedRate.styles';

interface EditableProducedRateProps {
  produced: number;
  hour: number;
  onValueChange?: (hourIndex: number, newValue: number) => void;
  disabled?: boolean;
}

export const EditableProducedRate: FC<EditableProducedRateProps> = ({
  produced,
  hour,
  onValueChange,
  disabled = false,
}) => {
  const [value, setValue] = useState(produced || 0);

  useEffect(() => {
    setValue(produced || 0);
  }, [produced]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(Number(newValue));
    onValueChange?.(hour, Number(newValue));
  };

  const handleBlur = () => {
    onValueChange?.(hour, Number(value));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.currentTarget.blur();
    }
  };

  return (
    <ContainerEditableProducedRate>
      <AllieInput
        type="number"
        value={value || 0}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        corner="rounded-edges-plus"
        placeholder="0"
        allieSize="small"
        min={0}
        style={{
          width: '100%',
          maxWidth: '140px',
          textAlign: 'center',
        }}
      />
    </ContainerEditableProducedRate>
  );
};
